import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InviteError.css';

const InviteError = ({ variant = 'not_found' }) => {
  const navigate = useNavigate();

  const content = {
    not_found: {
      title: 'Oops — ovaj pozivni link ne izgleda ispravno',
      message:
        'Link koji ste otvorili ne odgovara niti jednoj pozivnici na našem popisu. Molimo provjerite URL ili nas kontaktirajte za ispravan link.',
    },
    server: {
      title: 'Imamo problema s učitavanjem vaše pozivnice',
      message: 'Molimo pokušajte ponovno za trenutak.',
    },
  };

  const { title, message } = content[variant] || content.not_found;

  return (
    <div className="invite-error">
      <div className="invite-error__card">
        <div className="invite-error__icon" aria-hidden="true">
          {variant === 'not_found' ? '🔍' : '⚠️'}
        </div>
        <h1 className="invite-error__title">{title}</h1>
        <p className="invite-error__message">{message}</p>
        <button
          className="invite-error__button"
          onClick={() => navigate('/')}
        >
          Vrati se na početnu stranicu
        </button>
      </div>
    </div>
  );
};

export default InviteError;
